<template>
  <div>
    <div>
    <div class="remington-typed-font full-height text-align-center">
      <div class="inline-block margin-auto width-90 full-height vertical-middle">
        <nav class="navigationList inline-block">
          <ul>
            <li class="navbar-tabs"><router-link :to="{name: 'AboutUS'}">General</router-link></li>
            <li class="navbar-tabs"><router-link :to="{name: 'StructureMain'}">Structure</router-link></li>
            <li class="navbar-tabs"><router-link :to="{name: 'CampaignsMain'}">Campaigns</router-link></li><!--              <li>|</li>-->
            <li class="navbar-tabs"><router-link :to="{name: 'ProceduresMain'}">Procedures</router-link></li>
            <li class="navbar-tabs"><router-link :to="{name: 'RulesMain'}">Rules</router-link></li>
          </ul>
        </nav>
      </div>
    </div>
    </div>
  <div class="typed-on-paper-a4">
    <div class="text-align-center">
      <h1>RULES</h1>
    </div>
    <br><br>
    <div class="">
      <p class="text-align-left">
        Lorem ipsum dolor sit amet consectetur adipiscing elit, sed do eiusmod tempor
        incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris
        nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum
        dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia
        deserunt mollit anim id est laborum.
      </p>
    </div>
  </div>
  </div>
</template>

<script>

  export default {
    name: "InfoTemplate"
  }
</script>

<style scoped>

.iconImage {
  max-height: 40px;
}

.navbar-tabs {
  min-height: 0px;
  width: calc(100% - 0px); /* Whished widht in % minus 2x border size */
  padding: 20px;
  padding-bottom: 15px;
  font-family: "Remingtoned Type";
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  background-image: url("/frontend/src/assets/images/ftcpaper.png");
  /*background: linear-gradient(90deg, #ebebe9 1px, #ebe6e6 1px, #efeeec 1px, #e7e6e4 1px, #eae6e5 1px);*/
  box-shadow: 0px -5px 15px rgba(10,10,10,0.3);
  color: #1b1b1b;
}

.navigationList li {
  display: table-cell;
  font-size: 125%;
  text-align: center;
}

.navigationList li a {
  padding: 0px 40px;
  text-decoration: none;
  font-weight: bold;
  color: #1b1b1b;
}

.navigationList li a:hover{
  color: #1b1b1b;
  background: rgba(255, 255, 255, 0.5);
  border-color: #646464;
  border-radius: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/info/RulesMain.vue